// View mode - Toggle between Visual & Tiles with class toggle
// Note that the Product Cards list variable is reassigned often because of the DOM changes from filtering
class collectionView extends HTMLElement {

  constructor() {
    super();

    this.viewVisuals = this.querySelector('[data-view-visuals]');
    this.viewTiles = this.querySelector('[data-view-tiles]');
    this.viewOptions = [this.viewVisuals,this.viewTiles];

    /** Get DOM changes on the Product grid and reinit the check on localStorage collection view status **/
    
    // select the node that will be observed for mutations - the immediate parent of the product cards grid can't be selected because it's manipulated, DOM wise, by the Filters
    const collectionGridWrapper = document.querySelector('[data-collection-grid-wrapper]');
    
    // options for the observer (which mutations to observe)
    const config = { childList: true, subtree: true };
    
    // callback function to execute when mutations are observed
    const callback = mutations => {
      mutations.forEach(mutation => {
        if (mutation.type === 'childList') {
          this.init();
        }
      });
    };
    
    // create an observer instance linked to the callback function
    const observer = new MutationObserver(callback);
    
    // start observing the target node for configured mutations
    observer.observe(collectionGridWrapper, config);
    
    /** Get the click on the view options **/
    this.viewOptions.forEach((view) => {
      view.addEventListener('click', (event) => {
        this.switchView(view);
      });
    });

    /** Get the initial class values from the Local Storage, if there's any set **/
    this.init();
  }

  init() {
    
    // if the collectionView is saved to be Visual from previous actions, adjust the classes accordingly
    if (localStorage.collectionView == "visuals") {
      let productCards = document.querySelectorAll('[data-product-card');
      productCards.forEach(productCard => productCard.classList.add('product-card--alternative-view'));
      this.viewVisuals.classList.add('collection__view-item--active');
      this.viewTiles.classList.remove('collection__view-item--active');
    }

  }
  
  // update the localStorage values and the product card classes
  switchView(view) {
    let productCards = document.querySelectorAll('[data-product-card');
    if (view == this.viewVisuals) {
      localStorage.collectionView = "visuals";
      productCards.forEach(productCard => productCard.classList.add('product-card--alternative-view'));
    }
    else {
      localStorage.collectionView = "tiles";
      productCards.forEach(productCard => productCard.classList.remove('product-card--alternative-view'));
    }
    // move the active class
    this.viewOptions.forEach(viewOption => viewOption.classList.remove('collection__view-item--active'));
    view.classList.add('collection__view-item--active');
  }

}

if(!customElements.get('collection-view')) {
  customElements.define('collection-view', collectionView);
}